import gql from 'graphql-tag'

export const GET_PART_CATEGORIES = gql`
  query PartCategories($filter: GetPartCategoriesFilter) {
    partCategories(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      partCategories {
        data {
          partCategoryId
          companyId
          category
          hasRelation
        }
        pagination {
          page
          show
          total
        }
      }
    }
  }
`

export const GET_PART_CATEGORY_BY_ID = gql`
  query PartCategory($filter: GetPartCategoryFilter!) {
    partCategory(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      partCategory {
        partCategoryId
        companyId
        category
        hasRelation
      }
    }
  }
`

export const CREATE_PART_CATEGORY = gql`
  mutation CreatePartCategory($input: CreatePartCategoryInput!) {
    createPartCategory(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      createPartCategory {
        partCategoryId
      }
    }
  }
`

export const UPDATE_PART_CATEGORY = gql`
  mutation UpdatePartCategory($input: UpdatePartCategoryInput!) {
    updatePartCategory(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      updatePartCategory {
        category
        partCategoryId
      }
    }
  }
`

export const DELETE_PART_CATEGORY = gql`
  mutation DeletePartCategory($input: DeletePartCategoryInput!) {
    deletePartCategory(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      deletePartCategory {
        category
        partCategoryId
      }
    }
  }
`
